<div class="headerFlexW pr-4 m-3">
    <div class="content-block">
        <p class="bread-crumbs"> Tercerización de pagos / Nueva solicitud</p>
        <h2 class="">Solicitudes Tercerización</h2>
    </div>
    <div>
        <dx-button class="mr-3" text="Exportar Reporte" icon="export" type="default" (onClick)="export()"></dx-button>
        <dx-button text="Nueva solicitud" icon="plus" type="default" (onClick)="addRequest()"></dx-button>
    </div>
</div>

<div class="content-block">
    <div class="dx-card responsive-paddings">
        <div class="flex flex-wrap icons-descW mb-1">
            <div data-toggle="tooltip" title="Solicitud está en proceso de revisión" style="width: 125px;">
                <div style="text-align: center;"> Paso 1</div>
                <i class="fas fa-exclamation-triangle status-1 status-ico"></i> = Por aceptar
                <!-- <div style="text-align: center;"> Solicitud está en proceso de revisión</div> -->
            </div>
            <div data-toggle="tooltip" title="Solicitud recibida y cumple con requisitos" style="width: 125px;">
                <div style="text-align: center;"> Paso 2</div>
                <i class="far fa-check status-2 status-ico"></i> = Aceptada
                <!-- <div style="text-align: center;"> Solicitud recibida y cumple con requisitos</div> -->
            </div>
            <div data-toggle="tooltip" title="Líder aprobó solicitud y el recibo está disponible para su descarga" style="width: 125px;">
                <div style="text-align: center;"> Paso 3</div>
                <i class="fas fa-check-double status-2 status-ico"></i> = Aprobada
                <!-- <div style="text-align: center;"> Líder aprobó solicitud y el recibo está disponible para su descarga</div> -->
            </div>
            <div data-toggle="tooltip" title="Solicitud fue rechazada por el líder">
                <div style="text-align: center;color: white;"> . </div>
                <i class="fas fa-times status-4 status-ico"></i> = Rechazada
            </div>
            <div data-toggle="tooltip" title="Pago en proceso de liberación" style="width: 125px;">
                <div style="text-align: center;"> Paso 4</div>
                <i class="fal fa-money-check-edit-alt status-2 status-ico"></i> = Programada
                <!-- <div style="text-align: center;"> Pago en proceso de liberación</div> -->
            </div>
            <div data-toggle="tooltip" title="Pago fue realizado exitosamente" style="width: 125px;">
                <div style="text-align: center;"> Paso 5</div>
                <i class="far fa-check-circle status-2 status-ico"></i> = Completada
                <!-- <div style="text-align: center;"> Pago fue realizado exitosamente</div> -->
            </div>
            <div data-toggle="tooltip" title="Revisar mensaje de cancelación" style="width: 105px;">
                <div style="text-align: center;color: white;"> . </div>
                <i class="fas fa-ban status-4 status-ico"></i> = Cancelada
                <!-- <div style="text-align: center;"> Revisar mensaje de cancelación</div> -->
            </div>
            <div data-toggle="tooltip" title="Revisar mensaje de incidencia" style="width: 108px;">
                <div style="text-align: center;color: white;"> . </div>
                <i class="fas fa-engine-warning status-1 status-ico"></i> = Incidencia
                <!-- <div style="text-align: center;"> Revisar mensaje de incidencia</div> -->
            </div>

        </div>

        <dx-data-grid #dataGrid1 [dataSource]="requests" keyExpr="id" [showBorders]="true"
            [masterDetail]="{ enabled: true, template: 'detail', autoExpandAll: false }">
            
            <dxo-search-panel [visible]="true" [width]="240" placeholder="Buscar..."></dxo-search-panel>
            <dxo-load-panel [enabled]="true"></dxo-load-panel>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 25, 50, 100]" [showInfo]="true"></dxo-pager>
            <!-- <dxi-column dataField="id" caption="Folio"  alignment="center"></dxi-column> -->
            <dxi-column dataField="dateCreated" caption="Creada" cellTemplate="dateTemplate" alignment="center">
            </dxi-column>
            <dxi-column *ngIf="facturaSuperlativeVisible" dataField="facturaSuperlative" caption="Factoraje" alignment="center">
            </dxi-column>
            <dxi-column dataField="createdBy" caption="Usuario" alignment="center">
            </dxi-column>
            <dxi-column dataField="cmg.cmg" caption="CMG" alignment="center">
            </dxi-column>
            <dxi-column dataField="beneficiary.beneficiaryComercialName" caption="Beneficiario" alignment="center">
            </dxi-column>
            <dxi-column dataField="amount" caption="Monto" alignment="center" dataType="number" [format]="{ style: 'currency', currency: 'USD' }">
            </dxi-column>
            <dxi-column dataField="total" caption="Total" alignment="center" dataType="number" [format]="{ style: 'currency', currency: 'USD' }">
            </dxi-column>
            <dxi-column dataField="status" alignment="center" width="150px" caption="Status" cellTemplate="statusTemplate">
                <dxo-header-filter 
            [dataSource]="applyFilterTypes"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="status" alignment="center" width="100px" caption="" cellTemplate="statusIconTemplate" [allowHeaderFiltering]="false"></dxi-column>
            <dxi-column dataField="id" alignment="center" width="100px" caption="Editar" cellTemplate="editTemplate" [allowHeaderFiltering]="false"></dxi-column>
            

            <!-- <dxo-summary>
                <dxi-total-item column="companyName" summaryType="count">
                    <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
                </dxi-total-item>
                <dxi-total-item column="dispersionAmount" summaryType="sum" valueFormat="currency" precision="2">
                    <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
                </dxi-total-item>
                <dxi-total-item column="fees" summaryType="sum" valueFormat="currency">
                    <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
                </dxi-total-item>
                <dxi-total-item column="granTotal" summaryType="sum" valueFormat="currency">
                    <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
                </dxi-total-item>
            </dxo-summary> -->
            <div *dxTemplate="let d of 'dateTemplate'">
                <div *ngIf="d.value"> {{d.value|numberToDate}}</div>
            </div>
            <div *dxTemplate="let d of 'editTemplate'">
                <div > 
                    <dx-button icon="fas fa-pencil ico-sm" (onClick)="editRequest(d.value)" class="brand-color"></dx-button>
                </div>
            </div>

            <div *dxTemplate="let d of 'statusTemplate'">
                <div *ngIf="udta.level <= 3">
                    <a *ngIf="d.value === 1" [routerLink]="" (click)="openPopup(d.data)">Por aceptar</a>
                    <a *ngIf="d.value === 2" [routerLink]="" (click)="openPopup(d.data)">Aceptada</a>
                    <a *ngIf="d.value === 7" [routerLink]="" (click)="openPopup(d.data)">Aprobada</a>
                    <a *ngIf="d.value === 8" [routerLink]="" (click)="openPopup(d.data)">Rechazada</a>
                    <a *ngIf="d.value === 6" [routerLink]="" (click)="openPopup(d.data)">Programada</a>
                    <a *ngIf="d.value === 3" [routerLink]="" (click)="openPopup(d.data)">Completada</a>
                    <a *ngIf="d.value === 4" [routerLink]="" (click)="openPopup(d.data)">Cancelada</a>
                    <a *ngIf="d.value === 5" [routerLink]="" (click)="openPopup(d.data)">Incidencia</a>
                </div>
                <div *ngIf="udta.level == 4">
                    <span *ngIf="d.value === 1" >Por aceptar</span>
                    <a *ngIf="d.value === 2" [routerLink]="" (click)="openPopup(d.data)">Aceptada </a>
                    <a *ngIf="d.value === 7" [routerLink]="" (click)="openPopup(d.data)">Aprobada</a>
                    <a *ngIf="d.value === 8" [routerLink]="" (click)="openPopup(d.data)">Rechazada</a>
                    <span *ngIf="d.value === 6" >Programada</span>
                    <span *ngIf="d.value === 3" >Completada</span>
                    <span *ngIf="d.value === 4" >Cancelada</span>
                    <span *ngIf="d.value === 5" >Incidencia</span>
                </div>
                <div *ngIf="udta.level > 4">
                    <span *ngIf="d.value === 1" >Por aceptar</span>
                    <span *ngIf="d.value === 2">Aceptada</span>
                    <span *ngIf="d.value === 7">Aprobada</span>
                    <span *ngIf="d.value === 8">Rechazada</span>
                    <span *ngIf="d.value === 6" >Programada</span>
                    <span *ngIf="d.value === 3" >Completada</span>
                    <span *ngIf="d.value === 4" >Cancelada</span>
                    <span *ngIf="d.value === 5" >Incidencia</span>
                </div>
            </div>
            <div *dxTemplate="let d of 'statusIconTemplate'">
                <div *ngIf="udta.level <= 3">
                    <i *ngIf="d.value === 1" class="fas fa-exclamation-triangle status-1 status-ico"></i>
                    <i *ngIf="d.value === 2" class="far fa-check status-2 status-ico"></i>
                    <i *ngIf="d.value === 7" class="fas fa-check-double status-2 status-ico"></i>
                    <i *ngIf="d.value === 8" class="fas fa-times status-4 status-ico"></i>
                    <i *ngIf="d.value === 6" class="fal fa-money-check-edit-alt status-2 status-ico"></i>
                    <i *ngIf="d.value === 3" class="far fa-check-circle status-2 status-ico"></i>
                    <i *ngIf="d.value === 4" class="fas fa-ban status-4 status-ico"></i>
                    <i *ngIf="d.value === 5" class="fas fa-engine-warning status-1 status-ico"></i>
                </div>
                <div *ngIf="udta.level == 4">
                    <i *ngIf="d.value === 1" class="fas fa-exclamation-triangle status-1 status-ico"></i>
                    <i *ngIf="d.value === 2" class="far fa-check status-2 status-ico"></i>
                    <i *ngIf="d.value === 7" class="fas fa-check-double status-2 status-ico"></i>
                    <i *ngIf="d.value === 8" class="fas fa-times status-4 status-ico"></i>
                    <i *ngIf="d.value === 6" class="fal fa-money-check-edit-alt status-2 status-ico"></i>
                    <i *ngIf="d.value === 3" class="far fa-check-circle status-2 status-ico"></i>
                    <i *ngIf="d.value === 4" class="fas fa-ban status-4 status-ico"></i>
                    <i *ngIf="d.value === 5" class="fas fa-engine-warning status-1 status-ico"></i>
                </div>
                <div *ngIf="udta.level > 4">
                    <i *ngIf="d.value === 1" class="fas fa-exclamation-triangle status-1 status-ico"></i>
                    <i *ngIf="d.value === 2" class="far fa-check status-2 status-ico"></i>
                    <i *ngIf="d.value === 7" class="fas fa-check-double status-2 status-ico"></i>
                    <i *ngIf="d.value === 8" class="fas fa-times status-4 status-ico"></i>
                    <i *ngIf="d.value === 6" class="fal fa-money-check-edit-alt status-2 status-ico"></i>
                    <i *ngIf="d.value === 3" class="far fa-check-circle status-2 status-ico"></i>
                    <i *ngIf="d.value === 4" class="fas fa-ban status-4 status-ico"></i>
                    <i *ngIf="d.value === 5" class="fas fa-engine-warning status-1 status-ico"></i>
                </div>
            </div>
            <div *dxTemplate="let paymentRequest of 'detail'">
                <div class="flex flex-nowrap datagrid-detailsW">
                    <div class="mr-5 ml-5" style="white-space: pre-wrap!important;">
                        <h4>Detalles de la solicitud</h4>
                        <ul>
                            <li>Folio: {{paymentRequest.data.id}}</li>
                            <li>Compañía: {{paymentRequest.data.companyName}}</li>
                            <li>Concepto: {{paymentRequest.data.concept}}</li>
                            <li>Entrada: {{paymentRequest.data.entry}}</li>
                            <li>Razón Social: {{paymentRequest.data.requestSocial}}</li>
                            <li>Cantidad: {{paymentRequest.data.amount | currency}}</li>
                            <li>IVA: {{paymentRequest.data.tax | currency}}</li>
                            <!-- <li>Comisión: {{paymentRequest.data.fee | currency}}</li> -->
                            <li>TOTAL: {{paymentRequest.data.total - paymentRequest.data.fee | currency}}</li>
                        </ul>
                        <ul>
                            <li>Código CMG: {{paymentRequest.data.cmg.cmg}}</li>
                            <li>Desc: {{paymentRequest.data.cmg.desc}}</li>
                            <li>Lider: {{paymentRequest.data.cmg.leaderName}}</li>
                            <li>Departamento: {{paymentRequest.data.cmg.level1}} - {{paymentRequest.data.cmg.level1Cat}}</li>
                            <li>Categoria: {{paymentRequest.data.cmg.level2}} - {{paymentRequest.data.cmg.level2Cat}}</li>
                            <!-- <li>Cat 3: {{paymentRequest.data.cmg.level3}} - {{paymentRequest.data.cmg.level3Cat}}</li> -->
                        </ul>
                        <p>{{paymentRequest.data.notes}}</p>
                    </div>


                    <div class="mr-5 ml-5">
                        <h4>Detalles del Beneficiario</h4>
                        <ul>
                            <li>Persona: <span *ngIf="paymentRequest.data.beneficiaryIsInc">Física</span> <span
                                    *ngIf="!paymentRequest.data.beneficiaryIsInc">Moral</span></li>
                            <!-- <li>Nombre comercial: {{paymentRequest.data.beneficiary.beneficiaryLegalName}}</li> -->
                            <li>Nombre Comercial: {{paymentRequest.data.beneficiary.beneficiaryComercialName}}</li>
                            <li *ngIf="paymentRequest.data.beneficiaryIsInc">Razón social:
                                {{paymentRequest.data.beneficiary.beneficiaryLegalName}}</li>
                            <li *ngIf="!paymentRequest.data.beneficiaryIsInc">Nombre:
                                {{paymentRequest.data.beneficiary.beneficiaryFirstName}}
                                {{paymentRequest.data.beneficiary.beneficiarySecondName}}
                                {{paymentRequest.data.beneficiary.beneficiaryLastName}}
                                {{paymentRequest.data.beneficiary.beneficiarySecondLastName}}</li>
                            <li class="uper-case">RFC: {{paymentRequest.data.beneficiary.rfc}}</li>
                            <li>Email: {{paymentRequest.data.beneficiary.email}}</li>
                            <li>Teléfono: {{paymentRequest.data.beneficiary.phone}}</li>
                            <li>Banco: {{paymentRequest.data.beneficiary.bank}}</li>
                            <li>CLABE: {{paymentRequest.data.beneficiary.clabe}}</li>
                            <li>Cuenta: {{paymentRequest.data.beneficiary.accountNumber}}</li>
                            <li>Dirección: {{paymentRequest.data.beneficiary.adress}}</li>
                            <li>Ciudad: {{paymentRequest.data.beneficiary.city}}</li>
                            <li>Estado: {{paymentRequest.data.beneficiary.state}}</li>
                            <li>CP: {{paymentRequest.data.beneficiary.zip}}</li>
                        </ul>
                    </div>
                    <div class="mr-5 ml-5">
                        <!-- <h4>Descargar de la Solicitud</h4> -->
                        <br />
                        <div *ngIf="paymentRequest.data.attachments[0].fileName">
                            <div *ngFor="let image of paymentRequest.data.attachments" class="mb-2">
                                <a class="mr-3" target="_blank" href="{{image.url}}"><i class="far fa-file-search">{{image.fileName}}</i></a>
                                <a [routerLink]="" (click)="deleteFile(image.attachmentId)"><i class="far fa-times-circle status-4 status-ico"></i></a>
                            </div>
                        </div>
                        <div>
                            <dx-button [disabled]='paymentRequest.data.status !=7' id="button" class="" (onClick)="getRecibo(paymentRequest.data)" type="default"
                                 text="Descargar Recibo">
                            </dx-button>
                        </div>
                        <div *ngIf="paymentRequest.data.status > 3" style="max-width: 330px;">
                            <span style="white-space: pre-wrap!important;">Mensaje: {{paymentRequest.data.messages[0].message}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </dx-data-grid>

        <div class="d-none">
            <dx-data-grid #dataGrid2 [dataSource]="requests" keyExpr="id" [showBorders]="true">
                <dxo-export [enabled]="true" [allowExportSelectedData]="true" fileName="Reporte Tercerizacion"></dxo-export>
                <dxi-column dataField="id" caption="Folio"></dxi-column>
                <dxi-column dataField="dateCreated" caption="Fecha"></dxi-column>
                <dxi-column dataField="requestSocial" caption="Solicitante"></dxi-column>
                <dxi-column dataField="order" caption="Pedido"></dxi-column>
                <dxi-column dataField="entry" caption="Entrada"></dxi-column>
                <dxi-column dataField="cmg.cmg" caption="CMG"></dxi-column>
                <dxi-column dataField="amount" caption="Pago Proveedor(sin IVA)"></dxi-column>
                <dxi-column dataField="paymentWithoutIva" caption="Pago Superlative(sin IVA)"></dxi-column>
                <dxi-column dataField="tax" caption="IVA"></dxi-column>
                <dxi-column dataField="fee" caption="Comisión"></dxi-column>
                <dxi-column dataField="total" caption="Total"></dxi-column>
                <dxi-column dataField="" caption="Moneda"></dxi-column>
                <dxi-column dataField="concept" caption="Concepto"></dxi-column>
                <dxi-column dataField="beneficiary.beneficiaryComercialName" caption="Beneficiario"></dxi-column>
                <dxi-column dataField="cmg.level1Cat" caption="Categoria"></dxi-column>
                <dxi-column dataField="cmg.level2Cat" caption="Lider"></dxi-column>
                <dxi-column dataField="cmg.level3Cat" caption="Departamento"></dxi-column>
            </dx-data-grid>
        </div>
    </div>
</div>

<!-- POPUP -->

<dx-popup [width]="400" height="auto" [showTitle]="true" title="Cambio de Status" [dragEnabled]="false"
        [closeOnOutsideClick]="true" [(visible)]="popupVisible">
        <div *dxTemplate="let data of 'content'">
            <div class='dx-field mt-2'>
                <div class='dx-field-label'>Status</div>
                <div class='dx-field-value'>
                    <dx-select-box [dataSource]="udta.level > 3 ? liderStatussObj : statussObj" displayExpr="statusName" valueExpr="status" [(value)]="statusChangeObj.status">
                        <dx-validator>
                            <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                        </dx-validator>
                    </dx-select-box>
                </div>
            </div>
            <!-- <div *ngIf="statusChangeObj.status == 2 && (udta.level == 1 || udta.level == 4)" class='dx-field mt-2'>
                <div class='dx-field-label'>Status Lider</div>
                <div class='dx-field-value'>
                    <dx-select-box [dataSource]="liderStatussObj" displayExpr="statusName" valueExpr="status" [(value)]="statusChangeObj.messages[0].liderStatusId">
                    </dx-select-box>
                </div>
            </div> -->
            <div *ngIf="statusChangeObj.status > 3 && statusChangeObj.status != 7" class="dx-field">
                <div class="dx-field-label">Mensaje</div>
                <div class='dx-field-value'>
                    <dx-text-area [(value)]="message">
                        <dx-validator>
                            <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-area>
                </div>
            </div>
            <div class="float-right">
                <dx-button id="button" class="" [useSubmitBehavior]="true" type="default"
                    (onClick)="changeStatus($event)" text="Guardar">
                </dx-button>
            </div>
        </div>
    </dx-popup>
    